<template>
  <div>
    <h3>นโยบายความเป็นส่วนตัวสำหรับผู้ขนส่ง</h3>
    <md-content>
      <ol>
        <li>
          ขอบเขต
          <ol type="a">
            <li>
              นโยบายความเป็นส่วนตัวฉบับนี้มีผลใช้บังคับกับ เว็บไซต์ แอปพลิเคชัน และบริการอื่นของ Eziecorp ที่อ้างถึงหรือเชื่อมโยงถึงนโยบายนี้ (เรียกรวมกันว่า “บริการ” ของเรา)
            </li>
            <li>
              นโยบายความเป็นส่วนตัวฉบับนี้มีผลใช้บังคับไม่ว่าคุณจะใช้คอมพิวเตอร์ โทรศัพท์มือถือ แท็บเล็ต หรือโทรทัศน์ ในการเข้าถึงบริการของเรา
            </li>
          </ol>
        </li>
        <li>
          การเก็บรวบรวมข้อมูลส่วนบุคคล
          <ol type="a">
            <li>
              ข้อมูลส่วนบุคคนที่คุณให้ไว้แก่เราโดยตรง เช่น ชื่อ นามสกุล วันเกิด ที่อยู่ หมายเลขโทรศัพท์ หมายเลขประจำตัวประชาชน หมายเลขใบอนุญาตขับขี่ ประเภทพใบอนุญาตขับขี่ เลขบัญชีธนาคาร ชื่อบัญชีธนาคาร ทะเบียนรถ แบบรถ
            </li>
            <li>
              ข้อมูลซึ่งระบุตำแหน่งพื้นที่ของท่านในขณะใช้งานเว็บไซต์ กรณีที่ผู้ใช้เปิดให้เข้าถึงตำแหน่งบนเว็บบราวเซอร์ และการจัดส่งข้อมูลตำแหน่งพร้อมข้อมูลรายงานขนส่ง และบนแอปพลิเคชั่น Ezie360 กรณีที่มีการเข้าระบบและได้ให้ความยิมยอมในการเข้าถึงตำแหน่ง (Location Access) และการเข้าถึงตำแหน่งในเบื้องหลัง (Background Location Access)
            </li>
            <li>
              ข้อมูลที่ท่านจำเป็นต้องให้ไว้แก่บริษัท และบริษัทสามารถประมวลผลข้อมูลส่วนบุคคลนั้นได้ตามที่กฎหมายกำหนดโดยไม่ต้องขอความยินยอม ได้แก่
              <ul>
                <li>
                  การให้ข้อมูลเพื่อปฏิบัติตามกฎหมาย หรือ สัญญา หรือมีความจำเป็นต้องให้ข้อมูลเพื่อเข้าทำสัญญา หรือข้อมูลอื่นใดตามที่กฎหมายกำหนด หากท่านไม่ให้ข้อมูลส่วนบุคคลของท่าน บริษัทอาจไม่สามารถดำเนินการให้แก่ท่านตามที่ท่านประสงค์ หรือที่บริษัทได้แจ้งไว้ต่อท่าน หรือมีผลอื่นใดตามกฎหมาย
                </li>
                <li>
                  การให้ข้อมูลที่เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมาย เช่น การเก็บภาพของท่านในการจัดกิจกรรมต่างๆ ของบริษัท เป็นต้น
                </li>
              </ul>
            </li>
            <li>
              ข้อมูลส่วนบุคคลอื่น ซึ่งบริษัทจะขอความยินยอมจากท่านก่อน
            </li>
          </ol>
        </li>
        <li>
          วัตถุประสงค์ในการเก็บรวบรวม/การใช้/การเปิดเผยข้อมูลส่วนบุคคล
          <ol type="a">
            <li>
              การลงทะเบียนผู้ขนส่ง บริษัทจะจัดเก็บและใช้ข้อมูลเช่น ชื่อ นามสกุล วันเกิด ที่อยู่ หมายเลขโทรศัพท์ หมายเลขประจำตัวประชาชน หมายเลขใบอนุญาตขับขี่ ประเภทพใบอนุญาตขับขี่ เลขบัญชีธนาคาร ชื่อบัญชีธนาคาร ทะเบียนรถ แบบรถ เพื่อลงทะเบียนเป็นผู้ร่วมขนส่งกับทางบริษัท ผ่านบริการของเรา และเป็นข้อมูลสำหรับทำเอกสารหลักฐานการจ่ายค่าตอบแทน 
            </li>
            <li>
              การทำข้อมูลรายงานขนส่ง บริษัทจะจัดเก็บและใช้ข้อมูล ตำแหน่งปัจจุบันของท่าน ภาพถ่ายสถานที่ขนส่ง และข้อมูลที่เกี่ยวกับการขนส่ง ผ่าน บริการของเรา เพื่อประกอบเป็นข้อมูลขนส่ง และแบ่งปันข้อมูลดังกล่าว ให้กับบริษัทคู่ค้าของบริษัทที่ใช้บริการขนส่งในเที่ยวนั้นๆ เพื่อเป็นหลักฐานในการขนส่งแต่ละเที่ยว
            </li>
            <li>
              ประวัติตำแหน่งของท่านขณะทำการขนส่ง บริษัทจะจัดเก็บและใช้ข้อมูล ตำแหน่งปัจจุบันของท่าน ตลอดระยะเวลาที่ดำเนินการขนส่ง ผ่าน แอปพลิเคชั่น Ezie360 เพื่อประกอบเป็นข้อมูลขนส่ง และแบ่งปันข้อมูลดังกล่าว ให้กับบริษัทคู่ค้าของบริษัทที่ใช้บริการขนส่งในเที่ยวนั้นๆ เพื่อเป็นหลักฐานในการขนส่งแต่ละเที่ยว
            </li>
            <li>
              เพื่อดำเนินการตามกฎหมาย เช่น เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล การศึกษาวิจัยหรือสถิติซึ่งได้จัดให้มีมาตรการปกป้องที่เหมาะสม ทั้งนี้เพื่อคุ้มครองสิทธิและเสรีภาพของท่าน
            </li>
            <li>
              เพื่อวัตถุประสงค์อื่นที่ได้แจ้งขณะเก็บข้อมูลส่วนบุคคลของท่าน หรือวัตถุประสงค์อื่นที่เกี่ยวข้องกับข้อหนึ่งข้อใดข้างต้น
            </li>
            <li>
              บริษัทจะไม่ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน เว้นแต่ เป็นการใช้หรือเปิดเผยเท่าที่จำเป็นตามวัตถุประสงค์ที่ระบุไว้ข้างต้น หรือเป็นการเปิดเผยต่อบุคคลในบริษัท หรือบุคคลที่เกี่ยวข้องตามสัญญา หรือดำเนินการตามกฎหมาย หน่วยงานภาครัฐ หน่วยงานกำกับดูแล หรือได้รับความยินยอมจากท่าน
            </li>
          </ol>
        </li>
        <li>
          ผู้ที่อาจได้รับข้อมูลส่วนบุคคลของท่าน
          <ol type="a">
            <li>
              คู่ค้าของบริษัท พนักงานของบริษัทที่เกี่ยวข้อง
            </li>
            <li>
              หน่วยงานภาครัฐ หรือหน่วยงานกำกับดูแล หรือบุคคลใดที่บริษัทต้องเปิดเผยข้อมูล ภายใต้กฎหมาย ระเบียบ คำสั่ง ที่เกี่ยวข้องกับบริษัท หรือตามข้อตกลงที่บริษัทมีต่อหน่วยงานภาครัฐ หรือบุคคลอื่นใด
            </li>
          </ol>
        </li>
        <li>
          การรักษาความปลอดภัยของข้อมูล
          <ol type="a">
            <li>
              บริษัทใช้ Secure Socket Layer (SSL) ซึ่งเป็นมาตรฐานการรักษาความปลอดภัยของข้อมูลที่รับส่งผ่านอินเทอร์เน็ต รวมถึงมีการเข้ารหัสข้อมูลและจัดตั้ง Firewall โดย Secured Socket Layer (SSL) เป็นเทคโนโลยีในการเข้าสู่ข้อมูลผ่านรหัส เพื่อป้องกันผู้ที่แอบดักจับข้อมูลขณะที่มีการส่งผ่านเครือข่าย Internet การเข้าสู่ข้อมูลผ่านรหัสนี้จะทำให้ผู้ดักจับไม่สามารถเข้าใจความหมายของข้อมูลได้ นอกจากนี้ เทคโนโลยีนี้ยังใช้สำหรับการยืนยันความมีอยู่จริงของเว็บไซต์อีกด้วยบริษัทจะมีการปรับปรุงและทดสอบระบบเทคโนโลยีของบริษัทอย่างสม่ำเสมอเพื่อให้แน่ใจว่าข้อมูลส่วนบุคคลของท่านมีความปลอดภัยสูงสุดและน่าเชื่อถือ ในการนี้ บริษัทสงวนสิทธิในการเปลี่ยนแปลงเครื่องมือการรักษาความปลอดภัย หากบริษัทเห็นว่าเครื่องมือดังกล่าวมีมาตรฐานสูงขึ้นและสามารถรักษาความปลอดภัยของข้อมูลได้ดีมากยิ่งขึ้น
            </li>
            <li>
              กรณีบริษัททำความตกลงไว้กับบุคคลภายนอกในการพัฒนาและดูแลรักษาระบบ และการจัดสรรทรัพยากรหรือบริการในนามของบริษัท บุคคลภายนอกที่เข้ามาดำเนินงานให้บริษัท หรือดำเนินการในนามของบริษัท จะต้องตกลงรักษาข้อมูลส่วนบุคคลของท่านด้วยเช่นกัน
            </li>
          </ol>
        </li>
        <li>
          สิทธิของเจ้าของข้อมูลส่วนบุคคล
          <ol type="a">
            <li>
              ท่านที่เป็นเจ้าของข้อมูลส่วนบุคคลมีสิทธิขอเข้าถึง ขอรับสำเนาข้อมูลส่วนบุคคลที่เกี่ยวกับท่านซึ่งได้ให้ไว้และอยู่ในความควบคุมของบริษัท หรือขอให้เปิดเผยการได้รับข้อมูลส่วนบุคคลของท่านที่ท่านไม่ได้ให้ความยินยอม เว้นแต่ เป็นการคุ้มครองเจ้าของข้อมูล หรือสิทธิเสรีภาพของบุคคลอื่น เป็นการขัดหรือแย้งกับบทบัญญัติแห่งกฎหมายหรือคำสั่งศาล หรือกรณีอื่นตามที่กฎหมายกำหนด
            </li>
            <li>
              ท่านสามารถแจ้งยกเลิกให้บริษัทใช้งานข้อมูลส่วนบุคคล หรือเปิดเผยข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไว้ได้ภายหลังจากการยกเลิกดังกล่าว บริษัทอาจไม่สามารถให้บริการท่านได้อย่างเต็มความสามารถ หรือตามที่บริษัทได้แจ้งไว้ต่อท่านได้ ทั้งนี้ บริษัทอาจเก็บข้อมูลไว้เพื่อการตรวจสอบการให้บริการแก่ท่าน หรือเพื่อดำเนินการตามกฎหมาย โดยบริษัทจะไม่นำข้อมูลส่วนบุคคลของท่านไปใช้เพื่อวัตถุประสงค์อื่นอีกต่อไป
            </li>
            <li>
              หากบริษัทไม่ดำเนินการรักษาข้อมูลส่วนบุคคลตามที่กฎหมายกำหนด ท่านสามารถขอให้บริษัทดำเนินการทำลาย ลบ หรือระงับใช้ชั่วคราว หรือแปลงข้อมูลส่วนบุคคลให้อยู่ในรูปแบบข้อมูลที่ไม่ระบุชื่อ
            </li>
            <li>
              สิทธิอื่นใดตามที่กฎหมายกำหนด เช่น สิทธิในการแก้ไขข้อมูลส่วนบุคคล การระงับการใช้ข้อมูลส่วนบุคคล การคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้
            </li>
            <li>
              ท่านสามารถดำเนินการตามสิทธิข้างต้นโดยแจ้งทางอีเมล: admin@ezicorp.com
            </li>
          </ol>
        </li>
        <li>
          ข้อยกเว้นการดูแลรักษาข้อมูลส่วนบุคคล ในกรณีที่ไม่ถือว่าเป็นการกระทำที่ฝ่าฝืนต่อนโยบายการดูแลรักษาข้อมูลส่วนบุคคล เช่น
          <ol type="a">
            <li>
              ข้อมูลส่วนบุคคลนั้นได้ถูกเปิดเผยต่อสาธารณะแล้วตั้งแต่เวลาท่านได้เปิดเผยข้อมูลให้บริษัท หรือถูกเปิดเผยต่อสาธารณะโดยมิใช่ความผิดของบริษัท
            </li>
            <li>
              การเปิดเผยข้อมูลส่วนบุคคลโดยได้รับความยินยอมจากท่านไม่ว่าเป็นลายลักษณ์อักษร หรือการอนุญาตโดยวิธีการอื่นใด
            </li>
            <li>
              การเปิดเผยข้อมูลตามความจำเป็น เนื่องจากกระทำตามกฎหมาย คำสั่ง กฎข้อบังคับ คำสั่งศาล หน่วยงานของรัฐ หรือตามความจำเป็นอื่นใด
            </li>
          </ol>
        </li>
        <li>
          ระยะเวลาการเก็บข้อมูลส่วนบุคคล บริษัทจะเก็บข้อมูลส่วนบุคคลของท่านไว้ในระยะเวลาเท่าที่จำเป็น เพื่อให้บริการแก่ท่าน หรือดำเนินการตามวัตถุประสงค์ที่ระบุไว้
        </li>
        <li>
          การปรับปรุงนโยบายการดูแลรักษาข้อมูลส่วนบุคคล / การติดต่อบริษัท
          <ol type="a">
            <li>
              บริษัทอาจมีการปรับปรุงแก้ไข รายละเอียดเกี่ยวกับนโยบายการดูแลรักษาข้อมูลส่วนบุคคล ทั้งหมดหรือบางส่วน ถ้ามีการแก้ไข บริษัทจะปรับปรุงนโยบายการดูแลรักษาข้อมูลส่วนบุคคลทางเว็บไซต์
            </li>
            <li>
              ผู้ใช้งานสามารถแสดงความคิดเห็นต่อนโยบายการดูแลรักษาข้อมูลส่วนบุคคล ได้ที่ อีเมล: admin@ezicorp.com ทั้งนี้ ผู้ใช้งานตกลงให้ดุลยพินิจของบริษัทถือเป็นที่สุด
            </li>
          </ol>
        </li>
      </ol>
    </md-content>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>
